"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarInfo = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../../models");
var _BarInfoNode = require("./BarInfoNode");
var _jsxRuntime = require("react/jsx-runtime");
const BarInfo = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  if (!shoppingContext?.godModeOutput) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BarInfoNode.BarInfoNode, {
      label: _models.TranslationKey.consultantNr,
      value: shoppingContext.godModeOutput.consultantNumber,
      dataTestID: getTestId('info-consultant')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarInfoNode.BarInfoNode, {
      label: _models.TranslationKey.ruleSet,
      value: shoppingContext.godModeOutput.ruleSet,
      dataTestID: getTestId('info-ruleset')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarInfoNode.BarInfoNode, {
      label: _models.TranslationKey.moment,
      value: shoppingContext.godModeOutput.moment,
      dataTestID: getTestId('info-moment')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarInfoNode.BarInfoNode, {
      label: _models.TranslationKey.period,
      value: shoppingContext.godModeOutput.currentPeriodInfo,
      dataTestID: getTestId('info-period')
    })]
  });
};
exports.BarInfo = BarInfo;